module.exports = __webpack_public_path__ + "static/media/edit-red.86ea2812.png";